import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/system'

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100vw',
    height: '100vh',
  },
  icon: {
    [theme.breakpoints.down('tablet')]: {
      height: '100vh',
      width: '100vw',
    },
    [theme.breakpoints.up('tablet')]: {
      height: 400,
      width: 400,
    },
  },
}))

export { useStyles }
